const ru = {
    "loc_leaderboard": "лидерская таблица",
    "loc_leaderboard_info": "Заработать <span>очки</span>. Чем больше у тебя очков, тем более крутые <span>призы</span> будут тебе доступны",
    "loc_see_discount": "посмотреть скидку",
    "loc_turn_sound_off": "выключить звук",
    "loc_turn_sound_on": "включить звук",
    "loc_discount": "скидка",
    "loc_your_discounts": "твои скидки",
    "loc_go_to_the_website": "пойти на сайт",
    "loc_welcome": "добро пожаловать",
    "loc_what_is_your_name": "создать имя",
    "loc_incorect_name": "некорректное имя",
    "loc_map_screen": "экран карты",
    "loc_go_back": "назад",
    "loc_tutorial": "демо",
    "loc_next_tip": "следующая подсказка",
    "loc_phone_oriental": "Пожалуйста, переверни телефон для лучшего отображения игры",
    "loc_pixi_pause": "ПАУЗА",
    "loc_pause": "ПАУЗА",
    "loc_pixi_pts": "ОЧК",
    "loc_pixi_discount": "Скидка",
    "loc_bg_release_tutorial_1": "Собери три одинаковых оттенка в один ряд, меняя местами соседние ",
    "loc_bg_release_tutorial_2": "Каждый оттенок в ряду создает пустое место на фоне. Очисти весь фон, чтобы пройти уровень",
    "loc_drop_product_tutorial": "Подвинь помаду вниз, избавляясь от одинаковых оттенков",
    "loc_fill_bar_tutorial": "Собери оттенки в ряды, чтобы заполнить линию прогресса и закрыть уровень",
    "loc_lose_popup": "УРОВЕНЬ % ПРОВАЛЕН",
    "loc_win_popup": "УРОВЕНЬ % ЗАКРЫТ",
    "loc_hello": "Привет",
    "loc_start_game": "начать игру",
    "loc_logic_popup_top": "кажется, ты не залогинилась",
    "loc_logic_popup_bottom": "пожалуйста, залогинься или создай аккаунт",
    "loc_ log_in": "войти",
    "loc_tutorial_name_fillBar": `режим "заполнить помаду"`,
    "loc_tutorial_name_background_release": `режим "очистить фон" `,
    "loc_tutorial_name_drop_product": `режим "опустить помаду" `,
    "loc_loading": "ЗАГРУЗКА",
    "loc_login_placeholder": "имя",
    "loc_play": "играть",
    "loc_level": "уровень",
    "loc_create_account": "СОЗДАТЬ АККАУНТ",
    "loc_please_log_in": "ПОЖАЛУЙСТА, ВОЙДИ ИЛИ",
    "loc_done": "ГОТОВО",
    "loc_try_again": "ПОПРОБУЙ СНОВА",
    "loc_you_win": "ПОБЕДА!",
    "loc_login": "ВОЙТИ",
    "loc_login_info": "КАЖЕТСЯ, ТЫ НЕ ВОШЛА",
    "loc_oops": "УПС!",
    'loc_resume': 'ПРОДОЛЖИТЬ',

    "loc_tiles_dropped": 'Плитки опущены',
    "loc_pixi_sec": 'сек',
    "loc_pixi_min": 'мин',
    "loc_press_to_shuffle": "Нажми что бы перемешать",
    "loc_no_moves": "БОЛЬШЕ НЕТ ХОДОВ",
    "loc_comma": ','
};
export default ru;
